// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* globals window, __webpack_public_path__:writable */

// eslint has a `no-unused-vars` rule, which claims that the global
// value being updated here is unused. It doesn't document a way to
// write to an existing global.

import { bundlesPath } from 'config/shared';

if (window.assetBaseURL) {
  let newPublicPath = window.assetBaseURL;

  if (!newPublicPath.endsWith('/')) {
    newPublicPath += '/';
  }
  newPublicPath += `${bundlesPath}/`;
  __webpack_public_path__ = newPublicPath;
}
